import { render, staticRenderFns } from "./EvaluationRequestHistory.vue?vue&type=template&id=9bb28c2e&scoped=true"
import script from "./EvaluationRequestHistory.vue?vue&type=script&lang=js"
export * from "./EvaluationRequestHistory.vue?vue&type=script&lang=js"
import style0 from "./EvaluationRequestHistory.vue?vue&type=style&index=0&id=9bb28c2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb28c2e",
  null
  
)

export default component.exports